// extracted by mini-css-extract-plugin
module.exports = {"interval-connector":"styles_interval-connector__2MJGN"};